<!DOCTYPE html>
<!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/K_NrO-m57lg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> -->
<div mat-dialog-actions align="end">
<button mat-button (click)="closeDialog()" class="cross-btn">
    <img src="assets/images/cross-img.png" />
  </button>
</div>
<ion-card class="popup-card">
  <ion-grid class="ion-no-padding">
    <ion-row class="top-area ion-no-padding">
        <!-- <iframe width="560" height="500" src="https://www.youtube.com/embed/K_NrO-m57lg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> -->
      <ion-img class="home-gif" src="assets/gif/add-home-v3.gif"></ion-img>
    </ion-row>     
  </ion-grid>
</ion-card>
